/**
 * Shared seed: Activity → Analytics
 *
 * When the user has already loaded transactions on Activity and then navigates
 * to Analytics, we seed Analytics with Activity's data so the first paint is
 * instant instead of waiting for a full Firestore fetch.
 */

export interface TransactionWithDateSeed {
  id: string;
  userId: string;
  type: "income" | "expense" | "transfer" | "adjustment";
  amount: number;
  currency?: string;
  date: Date;
  note?: string;
  createdAt: unknown;
  title?: string;
  category?: string;
  isIncome?: boolean;
  accountId?: string;
  accountName?: string;
  fromAccountId?: string;
  toAccountId?: string;
  amountInDefaultCurrency?: number;
  defaultCurrencyAtTime?: string;
  defaultCurrencyRate?: number;
}

const seedCache = new Map<string, { transactions: TransactionWithDateSeed[]; timestamp: number }>();
const SEED_MAX_AGE_MS = 5 * 60 * 1000; // 5 minutes

export function setActivityTransactionsSeed(
  workspaceId: string,
  transactions: TransactionWithDateSeed[]
): void {
  if (!workspaceId) return;
  seedCache.set(workspaceId, { transactions, timestamp: Date.now() });
}

export function getActivityTransactionsSeed(
  workspaceId: string
): TransactionWithDateSeed[] | null {
  const entry = seedCache.get(workspaceId);
  if (!entry || Date.now() - entry.timestamp > SEED_MAX_AGE_MS) return null;
  return entry.transactions.length > 0 ? entry.transactions : null;
}
